import Platform from './../common/plat';
import IosDownloader from './iosApi';
import QBDownloader from './qbApi';
import YYBDownloader from './yybApi';
import NewsDownloader from './newsApi';
import WxDownloader from './wxApi';
import KBDownloader from './kbApi';
import QQDownloader from './qqApi';
import TVDownloader from './tvApi';
import TBSDownloader from './tbsApi';
import OtherDownloader from './otherApi';
import WSDownloader from './wsApi';
/**
 * 检测平台等信息，分配具体的下载器
 */
export function getAppDownloader(opt) {
    if (Platform.isQB || Platform.isQBJS || Platform.isQBNOVEL) {
        return new QBDownloader(opt);
    }
    if (Platform.isWX) {
        return new WxDownloader(opt);
    }
    if (Platform.isNews) {
        return new NewsDownloader(opt);
    }
    if (Platform.isQQ || Platform.isQZone) {
        return new QQDownloader(opt);
    }
    if (Platform.isTV) {
        return new TVDownloader(opt);
    }
    // 前几个可以在IOS场景使用jsapi
    if (Platform.isIos) {
        return new IosDownloader(opt);
    }
    if (Platform.isYYB) {
        return new YYBDownloader(opt);
    }
    if (Platform.isKB) {
        return new KBDownloader(opt);
    }
    if (Platform.isWs) {
        return new WSDownloader(opt);
    }
    if (Platform.isTBS) {
        return new TBSDownloader(opt);
    }
    return new OtherDownloader(opt);
}
